import React, { FC } from 'react';
import PropTypes from 'prop-types';
import logo from '../assets/img/ljslogo.png';
interface ILogoProps {
	width?: number;
	height?: number;
}
const Logo: FC<ILogoProps> = ({ width = 2155, height = 854 }) => {
	return (
		<img 
			src={logo}
			alt='Lojistigo Logo'
			//width={height !== 854 && !!height ? height * (2155 / 854) : width}
			height={width !== 2155 && !!width ? width * (854 / 2155) : height}
		/>
	);
};
Logo.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
};

export default Logo;
